<template>
  <span>
    <v-btn @click.stop="setDialog(true)" class="ma-1" color="red" outlined x-small>Delete</v-btn>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <delete-confirmation :dropdownValue="dropdownValue" @setDialog="setDialog"></delete-confirmation>
    </v-dialog>
  </span>
</template>

<script>
import DeleteConfirmation from "./DropdownValueDeleteConfirmation";

export default {
  components: { DeleteConfirmation },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    dropdownValue: { required: true, type: Object },
  },
};
</script>
